import React, { useMemo } from "react";

import RadioOffIcon from "@images/checkbox/radio-off.png";
import RadioOnIcon from "@images/checkbox/radio-on.png";
import RadioOffDisabledIcon from "@images/checkbox/radio-off-disabled.png";
import RadioOnfDisabledIcon from "@images/checkbox/radio-on-disabled.png";

const _nomarl: React.CSSProperties = {
  display: "inline-block",
  verticalAlign: "middle",
  margin: 0,
  padding: 0,
  width: "16px",
  height: "16px",
  background: `url(${RadioOffIcon}) no-repeat`,
  border: "none",
  cursor: "pointer",
};

const _checked: React.CSSProperties = {
  background: `url(${RadioOnIcon}) no-repeat`,
};

const _disabled: React.CSSProperties = {
  background: `url(${RadioOffDisabledIcon}) no-repeat`,
  cursor: "default",
};

const disabled_checked: React.CSSProperties = {
  background: `url(${RadioOnfDisabledIcon}) no-repeat`,
  cursor: "default",
};

interface SntRadioProps {
  value?: string;
  label?: React.ReactNode;
  selectedValue?: string;
  disabled?: boolean;
  onChange?: (value?: string) => void;
  className?: string;
}

function SntRadio({
  value,
  label,
  selectedValue,
  disabled = false,
  onChange,
  className,
}: SntRadioProps) {
  const _style = useMemo(() => {
    let rs = Object.assign({}, _nomarl);
    let _clss = "";
    if (value === selectedValue) {
      rs = Object.assign(rs, _checked);
      _clss += "snt_checked";
    }
    if (disabled) {
      _clss += " snt_checkbox_disable";
      if (value === selectedValue) {
        rs = Object.assign(rs, disabled_checked);
      } else {
        rs = Object.assign(rs, _disabled);
      }
    }

    return {
      style: rs,
      className: _clss,
    };
  }, [value, selectedValue, disabled]);

  function onClick() {
    if (!disabled) {
      onChange?.(value);
    }
  }

  return (
    <div className={`d-inline-block`}>
      <div className={`d-flex  ${className ? className : ""}`}>
        <div className="me-3">
          <div
            className={`${_style.className}`}
            style={_style.style}
            onClick={onClick}
          ></div>
        </div>
        <div className="align-middle">{label || ""}</div>
      </div>
    </div>
  );
}

export default SntRadio;
